<script setup lang="ts" generic="T">
import { computed, defineModel, ref } from '#imports'

interface YscInputCheckboxCardProps {
  id: string
  value: T
  name: string
}

const props = defineProps<YscInputCheckboxCardProps>()

const modelValue = defineModel<boolean | T[]>('checked')

const isChecked = computed(() => {
  return modelValue.value === true || (Array.isArray(modelValue.value) && modelValue.value.includes(props.value))
})

const inputRef = ref<HTMLInputElement>()

const ariaLabel = computed(() =>
  props.id ? (document.querySelector(`[for="${props.id}"]`) as HTMLLabelElement)?.textContent ?? undefined : undefined,
)

const onClick = () => {
  inputRef.value?.click()
}
</script>

<template>
  <button
    :id="id"
    role="checkbox"
    type="button"
    :aria-checked="isChecked"
    :aria-label="($attrs['aria-label'] as string) || ariaLabel"
    class="relative inline-block overflow-hidden rounded-sm focus-visible:ring focus-visible:ring-peacock-200 focus-visible:ring-offset-2 outline-none"
    :class="{
      'border border-gray-300': !isChecked,
      'border-2 border-gray-900': isChecked,
    }"
    @click="onClick"
  >
    <slot :checked="isChecked" />

    <input
      ref="inputRef"
      v-model="modelValue"
      type="checkbox"
      class="absolute appearance-none pointer-events-none -translate-x-[100%]"
      :value="value"
      :name="name"
      aria-hidden="true"
      tabindex="-1"
    >
  </button>
</template>
